import React from "react";

const ProgressStep = ({ className = "" }) => {
  return <div className={`w-4 h-1 rounded-xl ${className}`}></div>;
};

export default ProgressStep;
